import { render, staticRenderFns } from "./BalanceButton.vue?vue&type=template&id=2e7e1dd2&scoped=true"
import script from "./BalanceButton.vue?vue&type=script&lang=ts"
export * from "./BalanceButton.vue?vue&type=script&lang=ts"
import style0 from "./BalanceButton.vue?vue&type=style&index=0&id=2e7e1dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7e1dd2",
  null
  
)

export default component.exports